import React, { Component } from 'react'
import {
    BreadCrumb,
    UploadPanel,
    UploadList
}
    from "../../components"
import {AppSettings } from '../../configs'
import utilityHelper from '../../helpers/helperUtil'

import '../../assets/css/tor-template-list.css'

class UploadFileScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            transaction_no : 'T4',
            file_category: 'P',
        }

    }
 
    render() {
        return (

            <div className="tor tor-template-list">
                <div id="main-content">
                    <div className="page-body">
                    <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'Upload File',url:''}
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">Upload File</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">
                            <UploadPanel {...this.state} onUploadComplete={this.handleUploadComplete}/>
                        </div>
                        <hr />

                        <div className="sp-page-result-container">
                            <UploadList
                                key={"uploadlist-file-" + utilityHelper.genDateKey()}
                             {...this.state}/>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }
}

export default UploadFileScreen
